import { IImmobilizedInventory } from "../models";

export const data: IImmobilizedInventory = {
  name: "",
  asset_number: "",
  description: "",
  observation: "",
  purchase_amount: "",
  purchase_date: "",
  status: "Disponível",
  physical_location: "Tegra",
  invoice_number: "",
  responsible: "",
  isDeleted: false,
};
